import React from 'react'
import { LuNetwork } from 'react-icons/lu'

import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import useAppSelector from '@/hooks/useAppSelector'
import { useAuth } from '@/hooks/useAuth'
import { isDevelopment } from '@/lib/helpers/envHelpers'
import { truncateText } from '@/lib/helpers/helperFunctions'
import { cn } from '@/lib/utils'
import {
  selectCurrentNetwork,
  selectUserNetworks,
} from '@/redux/slices/session'

const UserNetworks: React.FC = () => {
  const currentNetwork = useAppSelector(selectCurrentNetwork)
  const networks = useAppSelector(selectUserNetworks)
  const { updateNetworkContext } = useAuth()

  if (!networks.length) {
    return null
  }

  return (
    <>
      <DropdownMenuLabel>Network</DropdownMenuLabel>

      {networks.map((network) => (
        <DropdownMenuItem
          onClick={() => updateNetworkContext({ network: network['@id'] })}
          key={network.id}
          title={isDevelopment() ? `ID: ${network.id.toString()}` : undefined}
          className={cn({
            'bg-accent': network.id === currentNetwork?.id,
          })}
        >
          <LuNetwork size={16} />

          {truncateText(network.name, { maxLength: 50 })}
        </DropdownMenuItem>
      ))}

      <DropdownMenuSeparator />
    </>
  )
}

export default UserNetworks
